import React, {Fragment} from "react";
import Select from "../../../form/Select";
import connectAdvanced from "react-redux/es/components/connectAdvanced";
import Icon from "../../../form/Icon";
import Button from "../../../form/Button";
import {optionsTemplate} from "../../../../utils/formatters";
import {getComponentConfig} from "../../../../utils/components";
import {sendRequest} from "../../../../utils/request";
import ContentLoader from "../../../layout/ContentLoader";

class Condition extends React.Component {

    state = {
        componentConfig: null,
        component: null,
        option: null,
        field: null
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.componentDidUpdate(this.props, {}, {});
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        this.componentConfigRequest && this.componentConfigRequest.abort();
        const component = this.props.properties[this.props.condition.property] && this.props.properties[this.props.condition.property].xtradata && this.props.properties[this.props.condition.property].xtradata.component;
        const option = this.props.properties[this.props.condition.property] && this.props.properties[this.props.condition.property].xtradata && this.props.properties[this.props.condition.property].xtradata.option;
        const field = this.props.properties[this.props.condition.property] && this.props.properties[this.props.condition.property].xtradata && this.props.properties[this.props.condition.property].xtradata.field;
        if ((component || null) !== (this.state.component || null) || (option || null) !== (this.state.option || null)) {
            this.setState({
                component,
                option
            }, () => {
                if (component) {
                    this.componentConfigRequest = getComponentConfig(component);
                    this.componentConfigRequest.then((componentConfig) => {
                        this.setState({
                            componentConfig,
                            component,
                            option,
                            field: field || componentConfig.idfield
                        });
                    });
                    this.componentConfigRequest.catch(() => {
                        this.setState({
                            componentConfig: null,
                            component: null,
                            option,
                            field: null
                        });
                    });
                } else {
                    this.setState({
                        componentConfig: null,
                        component: null,
                        option,
                        field: null
                    });
                }
            });
        }
    }

    render() {
        const component = this.state.component;
        const option = this.state.option;
        const field = this.state.field;
        const condition = this.props.condition;
        const condGroups = this.props.condGroups;
        const conds = this.props.conds;
        const index = this.props.index;
        const notInValues = condGroups[condition.property].map((c) => c !== condition ? c.property_value : null).filter((v) => !!v);
        return <div className="form-group">
            <div className="row">
                <div className="col-md-2">
                    <Button
                        color="default"
                        block={true}
                        onClick={(e) => {
                            e && e.preventDefault();
                            const newConds = [...conds];
                            newConds.splice(index, 1);
                            this.props.saveChanges(newConds);
                        }}
                    >
                        <Icon lib="fa" name="times-circle"/>
                    </Button>
                </div>
                <div className="col-md-5">
                    <Select
                        label={false}
                        optionname="DiscountConditionProperty"
                        storeType="local"
                        objectValue={false}
                        value={condition.property}
                        saveChanges={(field, value) => {
                            const newConds = [...conds];
                            newConds[index].property = value;
                            this.props.saveChanges(newConds);
                        }}
                    />
                </div>
                {(component && <div className="col-md-5">
                    <Select
                        component={component}
                        objectValue={true}
                        valueKey={field}
                        storeType="remote"
                        optionsTemplate={optionsTemplate(component)}
                        filter={notInValues.length ? [{field: field, value: notInValues, operator: "not in"}] : []}
                        saveChanges={(_field, value) => {
                            const newConds = [...conds];
                            newConds[index].property_value = value[field];
                            this.props.saveChanges(newConds);
                        }}
                        value={condition.property_value}
                        label={false}
                    />
                </div>) || (option && <div className="col-md-5">
                    <Select
                        optionname={option}
                        objectValue={true}
                        storeType="local"
                        filter={notInValues.length ? [{field: "optionid", value: notInValues, operator: "not in"}] : []}
                        saveChanges={(_field, value) => {
                            const newConds = [...conds];
                            newConds[index].property_value = value.optionid;
                            this.props.saveChanges(newConds);
                        }}
                        value={condition.property_value}
                        label={false}
                    />
                </div>)}
            </div>
        </div>;
    }
}

class Conditions extends React.Component {

    state = {
        properties: {},
        isLoading: true
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        const properties = await sendRequest({
            option: "componentlist",
            component: "option",
            itemsperpage: 0,
            optionname: "DiscountConditionProperty"
        });
        const props = this.groupBy(((properties && properties.items) || []).map((option) => {
            option.xtradata = JSON.parse(option.xtradata);
            return option;
        }), "optionid");
        Object.keys(props).map((key) => {
            props[key] = props[key][0];
        });
        this.setState({
            properties: props,
            isLoading: false
        });
    }

    saveChanges = (value) => {
        if (this.props.saveChanges) {
            this.props.saveChanges(this.props.name, value);
        }
    }

    groupBy = (xs, key) => {
        return xs.reduce((rv, x) => {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    render () {
        if (this.state.isLoading) {
            return <ContentLoader/>;
        }
        const conds = this.props.conditions || [];

        const condGroups = this.groupBy(conds, "property");

        const conditions = conds.map((condition, index) => <Condition properties={this.state.properties} index={index} condition={condition} condGroups={condGroups} conds={conds} saveChanges={this.saveChanges} />);
        return (
            <Fragment>
                {conditions}
                <Button
                    color="default"
                    block={true}
                    onClick={(e) => {
                        e && e.preventDefault();
                        const newConds = [...conds];
                        newConds.push({...this.props.newValues});
                        this.saveChanges(newConds);
                    }}
                >
                    <Icon lib="fa" name="plus" />
                </Button>
            </Fragment>
        );
    }

}

export default connectAdvanced((dispatch) => {
        return (store, nextOwnProps) => {
            const newValues = store.editors[nextOwnProps.type].initialValues;
            return {
                newValues,
                ...nextOwnProps
            };
        }
    }
)(Conditions);